(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function clampWrap(i, n) { return ((i % n) + n) % n; }

  function initGallery(gallery) {
    if (gallery.dataset.galleryInit === 'true') return;
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    if (slides.length === 0) return;
    gallery.dataset.galleryInit = 'true';

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var scope   = gallery.closest('[data-product-id]') || document;
    var thumbs  = Array.prototype.slice.call(scope.querySelectorAll('[data-gallery-thumb]'));
    var tag     = scope.querySelector('#ProductMainTag') || gallery.querySelector('.product__main-tag');

    var current = 0;

    function sync() {
      thumbs.forEach(function (t, idx) {
        var active = idx === current;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
      });
      var slide = slides[current];
      if (tag && slide && slide.dataset.label) tag.textContent = slide.dataset.label;
    }

    function goTo(i, smooth) {
      current = clampWrap(i, slides.length);
      track.scrollTo({
        left: current * track.clientWidth,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      sync();
    }

    // Keep index in sync when the user swipes/scrolls the track
    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current) { current = clampWrap(idx, slides.length); sync(); }
      }, 60);
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function (e) { e.preventDefault(); goTo(idx); });
    });

    // Re-align on resize (slide width changes)
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { goTo(current, false); }, 150);
    });

    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify theme editor support
  document.addEventListener('shopify:section:load', initAll);
})();

/* ── posted today / tomorrow countdown (per second, ends 3pm AEST / UTC+10) ── */
(function () {
  function two(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(el) {
    if (el.dataset.countdownInit === 'true') return;
    el.dataset.countdownInit = 'true';

    var out = el.querySelector('[data-ship-countdown-text]');
    if (!out) return;

    var hour = parseInt(el.getAttribute('data-hour'), 10);
    if (isNaN(hour)) hour = 15;                                  // 3pm

    var offsetH = parseFloat(el.getAttribute('data-offset'));
    if (isNaN(offsetH)) offsetH = 10;                            // AEST = UTC+10
    var offset = offsetH * 3600 * 1000;

    var todayTpl    = el.getAttribute('data-today')    || 'Order in {time} posted today';
    var tomorrowTpl = el.getAttribute('data-tomorrow') || 'Order in {time} posted tomorrow';

    // Next occurrence of `hour`:00 AEST, returned as an absolute epoch (ms).
    function nextTarget(now) {
      var aest = new Date(now + offset); // its UTC fields are the AEST wall clock
      var t = Date.UTC(aest.getUTCFullYear(), aest.getUTCMonth(), aest.getUTCDate(), hour, 0, 0, 0) - offset;
      if (now >= t) {
        t = Date.UTC(aest.getUTCFullYear(), aest.getUTCMonth(), aest.getUTCDate() + 1, hour, 0, 0, 0) - offset;
      }
      return t;
    }

    function tick() {
      var now = Date.now();
      var t   = nextTarget(now);
      var rem = Math.max(0, t - now);

      var s = Math.floor(rem / 1000);
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60);   s -= m * 60;
      var timeStr = two(h) + ':' + two(m) + ':' + two(s);

      // today vs tomorrow, based on the VIEWER'S local date.
      // If the viewer's timezone can't be read for any reason, fall back to AEST.
      var word;
      try {
        var td = new Date(t), nd = new Date(now);
        var same = td.getFullYear() === nd.getFullYear()
                && td.getMonth()    === nd.getMonth()
                && td.getDate()     === nd.getDate();
        word = same ? todayTpl : tomorrowTpl;
      } catch (e) {
        var ta = new Date(t + offset), na = new Date(now + offset);
        var sameA = ta.getUTCFullYear() === na.getUTCFullYear()
                 && ta.getUTCMonth()    === na.getUTCMonth()
                 && ta.getUTCDate()     === na.getUTCDate();
        word = sameA ? todayTpl : tomorrowTpl;
      }

      out.innerHTML = word.replace('{time}', '<strong>' + timeStr + '</strong>');
    }

    tick();
    var timer = window.setInterval(tick, 1000);
    el._countdownTimer = timer;
  }

  function initAll() {
    document.querySelectorAll('[data-ship-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

/* ── Bundle & save: choose an option, add it, then OPEN THE CART DRAWER ── */
(function () {
  function parseItems(el) {
    var items;
    try { items = JSON.parse(el.getAttribute('data-items') || '[]'); }
    catch (e) { items = []; }
    return (items || []).filter(function (i) { return i && i.id; });
  }

  var DRAWER_SELECTORS = [
    'cart-drawer', 'cart-drawer-component', '#CartDrawer', '#cart-drawer',
    '.cart-drawer', '[data-cart-drawer]', '.drawer--cart', '#sidebar-cart',
    '.js-cart-drawer', '.mini-cart', '#mini-cart'
  ];
  var BUBBLE_SELECTORS = [
    '#cart-icon-bubble', '.cart-count-bubble', '[data-cart-count]',
    '.cart-count', '#CartCount', '.header__cart-count', '.cart-link__bubble'
  ];

  function firstMatch(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // The Shopify section ID that wraps a given element (needed for the Section Rendering API).
  function sectionIdOf(el) {
    if (!el || !el.closest) return null;
    var sec = el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  // Drop freshly-rendered section markup into the live DOM so the drawer shows the new item.
  function applySection(sectionId, html) {
    if (!sectionId || !html) return false;
    var host = document.getElementById('shopify-section-' + sectionId);
    if (!host) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var inner = tmp.querySelector('#shopify-section-' + sectionId);
    host.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
    return true;
  }

  // Last resort when the drawer isn't a standard section: re-fetch the page and
  // swap in the freshly rendered drawer node (the server cart already has the item).
  function fallbackReplaceDrawer() {
    var drawer = firstMatch(DRAWER_SELECTORS);
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = null;
        for (var i = 0; i < DRAWER_SELECTORS.length; i++) {
          fresh = doc.querySelector(DRAWER_SELECTORS[i]);
          if (fresh) break;
        }
        var current = firstMatch(DRAWER_SELECTORS);
        if (fresh && current && current.parentNode) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  // Open whatever cart drawer the theme provides (covers Dawn / Horizon and most others).
  function openCartDrawer() {
    var drawer = firstMatch(DRAWER_SELECTORS);

    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) {}
    } else if (drawer && typeof drawer.showModal === 'function') {
      try { drawer.showModal(); } catch (e) {}
    } else if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.classList.add('active', 'is-open', 'open', 'drawer--active', 'is-active', 'js-drawer-open', 'visible');
      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
      document.body.classList.add('cart-drawer-open', 'drawer-open', 'js-drawer-open', 'overflow-hidden');
    }

    // Broadcast the common events themes / cart-drawer apps listen for (harmless if unused).
    ['cart:refresh', 'cart:open', 'cart-drawer:open', 'cart:updated', 'ajaxCart:updated', 'cart:build']
      .forEach(function (name) {
        try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} })); } catch (e) {}
      });
  }

  function initGroup(group) {
    if (group.dataset.bundleUpsellInit === 'true') return;
    group.dataset.bundleUpsellInit = 'true';

    var tiles = Array.prototype.slice.call(group.querySelectorAll('[data-bundle-select]'));
    var cta = group.querySelector('[data-bundle-upsell-cta]');
    if (!tiles.length || !cta) return;

    var ctaBase = (cta.textContent || 'Add to cart').trim();
    var soldLabel = (cta.getAttribute('data-soldout-label') || 'Sold out').trim();
    var selected = null;

    function select(tile) {
      selected = tile;
      tiles.forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      // Sold-out reflects ONLY the currently selected tile's variant.
      if (tile.getAttribute('data-available') === 'false') {
        cta.textContent = soldLabel;
        cta.disabled = true;
        cta.classList.add('is-soldout');
      } else {
        var priceEl = tile.querySelector('.bundle-upsell__price');
        var price = priceEl ? priceEl.textContent.trim() : '';
        cta.textContent = price ? (ctaBase + ' — ' + price) : ctaBase;
        cta.disabled = parseItems(tile).length === 0;
        cta.classList.remove('is-soldout');
      }
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () { select(tile); });
      tile.addEventListener('keydown', function (e) {
        var i = tiles.indexOf(tile);
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          select(tile);
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          var next = tiles[(i + 1) % tiles.length];
          next.focus(); select(next);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = tiles[(i - 1 + tiles.length) % tiles.length];
          prev.focus(); select(prev);
        }
      });
    });

    // Default selection: the highlighted tile, otherwise the first tile
    var def = group.querySelector('[data-bundle-select].is-highlight') || tiles[0];
    select(def);

    cta.addEventListener('click', function () {
      if (!selected) return;
      if (selected.getAttribute('data-available') === 'false') return;
      var items = parseItems(selected);
      if (!items.length) return;

      var original = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Adding…';

      function resetBtn() { cta.disabled = false; cta.textContent = original; }

      // The page's own product form — the theme already wires this up to update the
      // cart drawer (that's why the main Add-to-Cart works). We reuse it so bundles
      // go through the exact same, theme-native path.
      var mainForm = document.getElementById('ProductForm');

      // PREFERRED: submit the bundle's primary line through the theme's product form.
      function addViaThemeForm() {
        var idInput = mainForm.querySelector('input[name="id"]');
        var submitBtn = mainForm.querySelector('[data-atc]') || mainForm.querySelector('[type="submit"]');
        var primary = items[0];

        var prevId = idInput ? idInput.value : null;
        if (idInput) idInput.value = primary.id;

        // The main form adds quantity 1 by default; bump it if the primary line needs more.
        var qtyInput = mainForm.querySelector('input[name="quantity"]');
        var createdQty = false, prevQty = null;
        if (primary.quantity && primary.quantity > 1) {
          if (!qtyInput) {
            qtyInput = document.createElement('input');
            qtyInput.type = 'hidden';
            qtyInput.name = 'quantity';
            mainForm.appendChild(qtyInput);
            createdQty = true;
          } else { prevQty = qtyInput.value; }
          qtyInput.value = primary.quantity;
        }

        function fireSubmit() {
          if (typeof mainForm.requestSubmit === 'function') {
            try { mainForm.requestSubmit(submitBtn || undefined); }
            catch (e) { mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
          } else {
            mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          // Restore the form to its original single-variant state (the theme has
          // already read the form data synchronously at submit time).
          window.setTimeout(function () {
            if (idInput && prevId !== null) idInput.value = prevId;
            if (createdQty && qtyInput) { qtyInput.remove(); }
            else if (qtyInput && prevQty !== null) { qtyInput.value = prevQty; }
            resetBtn();
          }, 600);
        }

        // Multi-line bundles: add the extra lines via AJAX first, then submit the
        // primary through the form so the theme opens + refreshes the drawer with everything.
        var extras = items.slice(1);
        if (extras.length) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: extras })
          }).then(function () { fireSubmit(); }).catch(function () { fireSubmit(); });
        } else {
          fireSubmit();
        }
      }

      // FALLBACK: no product form present — add via AJAX and drive the drawer ourselves.
      function addViaAjax() {
        var drawerSection = sectionIdOf(firstMatch(DRAWER_SELECTORS));
        var bubbleSection = sectionIdOf(firstMatch(BUBBLE_SELECTORS));
        var sectionIds = [];
        if (drawerSection) sectionIds.push(drawerSection);
        if (bubbleSection && bubbleSection !== drawerSection) sectionIds.push(bubbleSection);

        var body = { items: items };
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (res) {
            var applied = false;
            if (res && res.sections) {
              Object.keys(res.sections).forEach(function (id) {
                if (applySection(id, res.sections[id])) applied = true;
              });
            }
            if (applied) { openCartDrawer(); resetBtn(); return; }
            return fallbackReplaceDrawer().then(function () { openCartDrawer(); resetBtn(); });
          })
          .catch(resetBtn);
      }

      if (mainForm) addViaThemeForm();
      else addViaAjax();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bundle-upsell-group]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
